module.exports = __webpack_public_path__ + "static/media/bbq_restaurant_menu_illustration_2015.771b89ab.webp";